import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconFilterSearch } from "@tabler/icons-react";

export const dataUA = [
  { key: "all", value: "All" },
  { key: "name", value: "Name" },
  { key: "effect", value: "Effect" },
  { key: "trigger", value: "Trigger" },
  { key: "affinity", value: "Affinity" },
];

export default function SearchSelect({
  selected,
  setSelected,
  customData = undefined,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  customData?: Item[];
}) {
  let data: Item[] = [];
  if (customData) {
    data = customData;
  } else {
    data = [
      { key: "all", value: "All" },
      { key: "name", value: "Name" },
      { key: "effect", value: "Effect" },
      { key: "trigger", value: "Trigger" },
      { key: "type", value: "Type" },
    ];
  }

  return (
    <GenericFilter
      classNames={"w-[114px]"}
      triggerClassNames={"rounded-l-md rounded-r-none"}
      selected={selected}
      setSelected={setSelected}
      startContent={<IconFilterSearch height={30} width={30} />}
      label="Search Filter"
      selectionMode="single"
      color="primary"
      data={data}
    />
  );
}
